import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Problems() {
  return <section aria-labelledby="problemas-title" className="w-full bg-ink-800" data-id="element-173" data-mp="1czwpwhwsciqm">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-174" data-mp="1cxtpr51x5986">
        <div className="mx-auto max-w-3xl text-center" data-id="element-175" data-mp="1hxy6mw6qo5yx">
          <SectionLabel data-id="element-176" data-mp="kb932hwe1lay">La realidad de las fuerzas básicas en México</SectionLabel>
          <h2 id="problemas-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-177" data-mp="k9ee8shzx91l">
            Si tu hijo o hija juega futbol, estas situaciones te van a sonar conocidas
          </h2>
        </div>
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-178" data-mp="z1oljoxf6f5f">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-xl border border-ink-border bg-ink-card p-5 shadow-panel transition-colors duration-150 ease-out hover:border-red-500/40" data-id="element-179" data-mp="1k82jpfmdhpa">
              <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500/15 text-red-400" data-id="element-180" data-mp="185sd5nf1k30">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-181" data-mp="3nnqiza557rss" />
              </span>
              <p className="text-[15px] leading-relaxed text-body" data-id="element-182" data-mp="3nlnw2yzaeesa">{problem}</p>
            </li>)}
        </ul>
        <div className="mt-10 rounded-2xl border border-ink-border bg-ink-950 p-8 text-center shadow-panel" data-id="element-183" data-mp="3en23sc40jleb">
          <p className="font-display text-2xl font-bold leading-snug text-white md:text-3xl" data-id="element-184" data-mp="39npgxrd56ebq">
            Ninguna familia debería tomar decisiones así de importantes a ciegas
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base text-subtle" data-id="element-185" data-mp="17wm54yrimtpl">
            El futbol base en México no se detiene a explicarte sus reglas.{' '}
            <span className="font-semibold text-brand-greenSoft" data-id="element-186" data-mp="12ysyy5q7pzpb">Este método sí.</span>
          </p>
        </div>
      </div>
    </section>;
}